import styles from "./index.module.scss";
import { Button } from "../Button";
import { Modal } from "@mui/material";
import close from "../../../assets/images/close-icon.svg";
import GrayLine from "../GrayLine";
import requestIcon from "../../../assets/images/request-icon.svg";
import { useState, useEffect } from "react";
import warningIcon from "../../../assets/images/WarningImg.svg"
import { Program, Question } from "../../../pages/Registration";

interface CustomPopUpProps {
  open: boolean;
  onclose?: () => void;
  description: string;
  onConfirm: () => void;
  confirmText: string;
  question: Question;
  allocatedProgram: Program | null | undefined;
  isShowModal: boolean;
}
const CustomPopup: React.FC<CustomPopUpProps> = ({
  open,
  onclose,
  description,
  onConfirm,
  confirmText,
  question,
  allocatedProgram,
  isShowModal
}) => {
  const [showCard, setShowCard] = useState(false);

  // Reset showCard whenever modal is opened
  useEffect(() => {
    if (open) {
      setShowCard(false);
    }
  }, [open]);

  const handleClose = ()=> {
    if (onclose) {
      setShowCard(true);
      onclose();
    }
  }

  const handleConfirm = () => {
    onConfirm();
    setShowCard(true);
  }

  return (
    <>
      {
      !showCard && allocatedProgram && isShowModal ?
      <Modal
      open={open}
      onClose={handleClose}
      className={styles.modal}
      data-testid="custom-popup-modal"
    >
      <div className={styles.container} data-testid="custom-popup-container">
        <div className={styles.header} data-testid="custom-popup-header">
          <div
            className={styles.headContainer}
            data-testid="custom-popup-head-container"
          >
            <div
              className={
                styles.modalHeader
              }
              data-testid="custom-popup-icon-title"
            >
              <img
                src={
                  requestIcon
                }
                alt="request icon"
                className={
                  styles.errorIcon
                }
                data-testid="custom-popup-icon"
              />
              <p>Important</p>
            </div>
            {onclose && (
              <div
                className={styles.closeIcon}
                data-testid="custom-popup-close-icon-container"
              >
                <img
                  src={close}
                  alt="close"
                  className={styles.closeIcon}
                  onClick={handleClose}
                  data-testid="custom-popup-close-icon"
                />
              </div>
            )}
          </div>
          <GrayLine data-testid="custom-popup-gray-line" />
        </div>
        <p
          id="popup-description"
          className={styles.containerText}
          data-testid="custom-popup-description"
        >
          {description}
        </p>
        
          <div
            className={styles.buttonContainer}
            data-testid="custom-popup-button-container"
          >
            <Button
              onClick={handleConfirm}
              buttonClassName={styles.confirmButton}
              buttonTextClassName={styles.confirmText}
              datatestid="custom-popup-confirm-button"
              datatestidText={`${confirmText}`}
            >
              {confirmText}
            </Button>
          </div>
      </div>
      </Modal>
      : 
      <div className={styles.cardContainer}>
              <div className={styles.contentContainer}>
                <div className={styles.ImageContainer}>
                  <img 
                    src={warningIcon}
                    alt="gst card"
                    className={styles.RazorPay}
                  />
                </div>
                <div className={styles.cardContent}>
                  <div>Important! {description}</div>
                 
                </div>
              </div>
          </div>
          }
    </>
  );
};

export default CustomPopup;
